<p class="subtitle has-text-weight-bold is-size-3">Forecast Meteogram</p>
<!-- <app-image-table [headers]="headers" [data]="getImageSources()" ></app-image-table> -->
<app-image-columns [data]="getImageSources()" [column]="2"></app-image-columns>